<h2 class="first_title">Attivit&agrave; da completare</h2>
<div export-help [pageNumber]="'158'"></div>
<div class="content-page-wrapper">
	<div class="standardpanel">
		<ng-template [ngIf]="attivitaCompletareResponse">
		<ul attivita-completare-list *ngIf="attivitaCompletareList.length > 0" class="att_completare" [attivitaList]="attivitaCompletareList" [slice]="numToViewAttivitaCompletare"></ul>
		<div *ngIf="attivitaCompletareList.length == 0">
			<p class="allinea_centro">Non ci sono attivit&agrave; da completare</p>
		</div>
		</ng-template>
	</div>
       
	<div *ngIf="attivitaCompletareResponse"  class="standardpanel">
		<div class="row">				
			<p *ngIf="attivitaCompletareResponse.numeroAttivitaTotali > attivitaCompletareList.length" class="allinea_centro col-sm-12">
					<a href="javascript:void(0);" (click)="loadProssimeAttivitaCompletare()">
					<strong>Carica altri risultati</strong></a></p>					
			<p *ngIf="attivitaCompletareResponse.numeroAttivitaTotali <= attivitaCompletareList.length" class="allinea_centro col-sm-12"><strong>Non ci sono altri risultati</strong></p>				
			<p class="allinea_centro col-sm-12"><strong>Risultati {{attivitaCompletareList.length}} di {{attivitaCompletareResponse.numeroAttivitaTotali}}</strong></p>
		</div>
	</div>
</div>